import { render, staticRenderFns } from "./CRCalendarView.vue?vue&type=template&id=087243c7&scoped=true"
import script from "./CRCalendarView.vue?vue&type=script&lang=js"
export * from "./CRCalendarView.vue?vue&type=script&lang=js"
import style0 from "./CRCalendarView.vue?vue&type=style&index=0&id=087243c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087243c7",
  null
  
)

export default component.exports